import { gql } from '@apollo/client';

export default gql`
  query profileLoyaltyMemberTierHistory($membershipNumber: String!) {
    profileLoyaltyMemberTierHistory(membershipNumber: $membershipNumber) {
      changeReasonType
      createdByName
      createdDate
      fromTierStartDate
      lastModifiedBy
      lastModifiedDate
      loyaltyProgramMember
      name
      newTier
      oldTier
      tierChangeReason
      toTierStartDate
    }
  }
`;
